'use strict';

require('../company/CompanyLogoService.js');
function CompanyGuestNavCtrl(
  $scope,
  $stateParams,
  $state,
  $timeout,
  logo,
  companies,
  userInformation
) {
  var searchTimeout;
  $scope.logo = logo;
  $scope.companies = companies;
  $scope.companyId = $stateParams.companyId;
  $scope.userInfo = userInformation;

  $scope.filter = {
    q:     null,
    qType: "GENERAL",
    page:  null
  };

  $scope.$on('$stateChangeSuccess', function() {
    if(!searchTimeout) {
      $scope.filter.q     = $state.params.q;
      $scope.filter.qType = $state.params.qType || "GENERAL";
    }
  });

  function getCompanyById(companies, companyId) {
    var ret = false;

    companies.forEach(function(c) {
      if(c.id === companyId) {
        ret = c;
      }
    });

    return ret;
  }

  $scope.currentCompany = getCompanyById($scope.companies, $stateParams.companyId);

  $scope.$watchCollection("[filter.q, filter.qType]", function(newValues, oldValues) {
    var newQ = newValues[0] || "";
    var oldQ = oldValues[0] || "";

    /* If we have a string and a change, it is either q or qType.
       If we do not have a string but the string is changed, then user might want
       unfiltered list */
    if(newQ.trim().length > 0 || newQ !== oldQ) {
      if(searchTimeout){
        $timeout.cancel(searchTimeout);

        searchTimeout = null;
      }

      searchTimeout = $timeout(function () {
        if (angular.isDefined(newValues[0])) {
          if('' === newValues[0].trim()) {
            $scope.filter.q = null;
          }

          $state.go('root.company-guest.publications.list', $scope.filter);

          searchTimeout = null;
        }
      }, 300);
    }
  });
}

CompanyGuestNavCtrl.resolve = {
  logo: ['$stateParams', 'CompanyLogoService', function($stateParams, CompanyLogoService) {
    return CompanyLogoService.get({companyId: $stateParams.companyId}).$promise;
  }],
  companies: ['CompanyService', function(CompanyService) {
    return CompanyService.query().$promise;
  }]
};

module.exports = CompanyGuestNavCtrl;

angular.module('dokiv')
  .controller('CompanyGuestNavCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    '$timeout',
    'logo',
    'companies',
    'userInformation',
    CompanyGuestNavCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/CompanyGuestNavCtrl.js
// module id = 281
// module chunks = 0